import { render, staticRenderFns } from "./editPw.vue?vue&type=template&id=48bd62f2&scoped=true&"
import script from "./editPw.vue?vue&type=script&lang=js&"
export * from "./editPw.vue?vue&type=script&lang=js&"
import style0 from "./editPw.vue?vue&type=style&index=0&id=48bd62f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48bd62f2",
  null
  
)

export default component.exports